import { Typography } from "@mui/material";
import React from "react";
import { MuiNavLink } from "./MuiNavLink";

interface BasicErrorProps {
  style?: React.CSSProperties;
  error: string | JSX.Element;
  navlink?: string;
  navtext?: string;
}

export const BasicError: React.FC<BasicErrorProps> = ({ style, error, navtext, navlink }) => {
  return (
    <div style={style}>
      <Typography component="div" variant="overline" align="center">
        Error: {error || "Unknown Error"}
      </Typography>
      {navlink && (
        <MuiNavLink to={navlink} fontWeight="bold" fontSize="18px" textAlign="center" display="block">
          {navtext}
        </MuiNavLink>
      )}
    </div>
  );
};

export default BasicError;
